import { XPPlusIcon } from "@/components/icons/XPPlusIcon";
import { useUserLocale } from "@/hooks/useUserLocale";
import { Progress } from '@heroui/progress';
import { useEffect, useState } from "react";

export function XpGainedDetailedBadge({ xpGained, xpCurrent, experienceTillNextLevel, currentRankLevel }: { xpGained: number, xpCurrent: number, experienceTillNextLevel: number, currentRankLevel: number }) {
    const { t, locale } = useUserLocale();

    const [progressValue, setProgressValue] = useState(0);  

    useEffect(() => {
        if (experienceTillNextLevel) {
            setProgressValue((xpCurrent / experienceTillNextLevel) * 100);
        }
    }, [xpCurrent, experienceTillNextLevel]);

    const xpLeft = experienceTillNextLevel - xpCurrent;

    return (
        <div className="flex flex-col gap-2">
            <div className="font-bold text-sm text-gray-500">
                {t.experienceBar.xpGained}:
            </div>
            <div className="flex flex-row items-center gap-1">
                <span><XPPlusIcon className="w-4 h-4 text-green-500"/></span><span className="text-2xl font-bold text-green-500">{xpGained}</span><span className="text-sm text-gray-400">XP</span>
            </div>
            {/* Progress bar with current experience till next level */}

            <Progress 
                value={progressValue} 
                color="warning"
                size="lg"
                radius="full"
                aria-label={"Learning Progress"}
                classNames={{
                    base: "h-4",
                    track: "bg-gray-200",
                    indicator: "bg-gradient-to-r from-yellow-400 to-yellow-300"
                }}
            />

            <div className="flex flex-row items-center gap-2">
                <span className="text-xs text-gray-500">
                    {xpLeft} {t.experienceBar.xpLeftToNextLevel}
                </span>
            </div>
        </div>
    );
}